const getDecimalSeparator = () => {
    const n = 1.1;
    return n.toFixed(1).substring(1, 2);
};

export default (amount, separator = ' ', fixed = 2) => {
    const decimalSeparator = getDecimalSeparator();
    if (typeof amount !== 'number') {
        return amount;
    }
    const fixedNumber = amount.toFixed(fixed).replace(decimalSeparator, ',');
    return fixedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
